import React, { ReactNode } from 'react'

import { preventEvents } from '@/utils/eventUtils'

interface IXLTProps {
  urls: string[]
  children?: ReactNode
}

const LINK_DELIMITER = '$L'

export const LinkText = (props: IXLTProps) => {
  const onClick = () => {
    preventEvents()
  }

  if (typeof props.children !== 'string') {
    return <></>
  }

  return (
    <>
      {props.children.split(LINK_DELIMITER).map((chunk, index) => {
        const isLinkText = index % 2 === 1
        const urlIndex = Math.floor(index / 2)

        if (isLinkText) {
          return (
            <a key={index} href={props.urls[urlIndex]} onClick={onClick}>
              {chunk}
            </a>
          )
        }

        return chunk
      })}
    </>
  )
}
